import styled from 'styled-components';
import { zIndex, spacing, duration, easing, colors, focusRings } from 'ui/theme';
import { Help24 } from 'ui/icons/aurora/24px/Help24';
import { PopoverTrigger } from './PopoverTrigger';
import { PopoverContent } from './PopoverContent';

export const Help24Colored = styled(Help24)`
  display: flex;
  border-radius: ${spacing.threeQuarter};
  transition: all ${duration.long} ${easing.standard};
  &:hover {
    background: ${colors.backgroundPrimaryHover};
    path {
      fill: ${colors.iconPrimaryHover};
    }
  }
  &[data-active='true'] {
    background: ${colors.backgroundInteractive};
    path {
      fill: ${colors.iconInteractiveHover};
    }
  }
`;

export const PopoverTriggerWithOutline = styled(PopoverTrigger)`
  border-radius: ${spacing.threeQuarter};
  cursor: pointer;
  &:focus-visible {
    box-shadow: ${focusRings.primary.simple};
    outline: none;
  }
`;

export const PopoverContentStyled = styled(PopoverContent)`
  &[data-in-modal='true'] {
    /** if popover content is used in a modal, z-index needs to be updated */
    z-index: ${zIndex.tooltip};
  }
`;
